import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { title: String, count: Number, icon: String }

  connect() {
    this.render()
  }

  render() {
    const title = this.displayTitle
    this.element.title = title

    this.element.replaceChildren()

    const isDropdownHeader = this.element.classList.contains("communication-dropdown__link")
    const showIcon = this.hasIconValue

    if (showIcon || isDropdownHeader) {
      const wrapper = document.createElement("div")
      wrapper.className = "flex items-center tw-gap-[8px]"

      if (showIcon) {
        const iconEl = document.createElement("span")
        iconEl.className = "material-icons-outlined communication-icon blue-gray-600"
        iconEl.textContent = this.iconValue
        wrapper.append(iconEl)
      }

      const titleEl = document.createElement("span")
      titleEl.className = "blue-gray-900 tw-font-medium text-md"
      titleEl.textContent = title

      wrapper.append(titleEl)
      if (isDropdownHeader && this.countValue > 0) {
        const dotEl = document.createElement("span")
        dotEl.className = "communication-count-dot"
        wrapper.append(dotEl)
      }
      this.element.append(wrapper)
    } else {
      this.element.textContent = title
    }
  }

  get displayTitle() {
    const base = (this.titleValue || "").trim()
    const count = Number.isFinite(this.countValue) ? this.countValue : nil
    if (this.element.classList.contains("communication-dropdown__link")) {
      return base
    }

    return count ? `${base} (${count})` : base;
  }
}
